import React from 'react'
import SettingsMetaData from '../../../../Components/Hooks/useSettingsMetaData';

function Division() {
  return (
    <SettingsMetaData propertyName={"Inspection_Team"} viewPropertyName={"Division"} />
  );
}

export default Division